<script>
export default {
  props: {
    showSearch: Boolean,
    searchItemArray: Array
  },
  data() {
    const ceraterForm = this.searchItemArray || [];
    const formData = {};
    ceraterForm.forEach(o => {
      if (o.value === "" || o.value) {
        formData[o.keyName] = o.value;
      } else {
        formData[o.keyName] = undefined;
      }
    });
    return {
      formData
    };
  },
  methods: {
    onSubmit() {
      const formatData = {};
      for (let item in this.formData) {
        if (this.formData[item] && typeof this.formData[item] === "string") {
          formatData[item] = this.formData[item].trim();
        } else {
          formatData[item] = this.formData[item];
        }
      }

      this.$emit("onSearch", formatData);
    },
    onChange(key) {
      const formatData = {};
      for (let item in this.formData) {
        if (this.formData[item] && typeof this.formData[item] === "string") {
          formatData[item] = this.formData[item].trim();
        } else {
          formatData[item] = this.formData[item];
        }
      }
      this.$emit("onChange", formatData);
    },
    onSelectValue(refName, value) {
      if (value === false && this.$refs[refName]) {
        const refObj = this.$refs[refName][0];
        refObj.blur();
      }
    }
  }
};
</script>

<template>
  <el-form
    :model="formData"
    class="demo-form-inline searchFormNew"
    size="small"
    @keyup.enter.native="onSubmit"
  >
    <div v-for="item in searchItemArray" :key="item.keyName">
      <el-form-item v-if="item.type==='text'" :label="item.label" class="labelStyle">
        <el-input
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
          class="labelInput"
          clearable
          :placeholder="item.label"
        ></el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type==='select'" class="labelStyle" :label="item.label">
        <el-select
          v-model="formData[item.keyName]"
          class="labelInput"
          placeholder="请选择"
          @visible-change="(value) => onSelectValue(item.keyName, value)"
          @change="onChange(item.keyName)"
          filterable
          clearable
          :ref="item.keyName"
        >
          <el-option
            v-for="child in item.children"
            :key="child.keyName"
            :label="child.label"
            :value="child.keyName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="item.type==='cascader'" class="labelStyle" :label="item.label">
        <el-cascader
          v-model="formData[item.keyName]"
          :ref="item.keyName"
          class="cascaderInput"
          popper-class="searchFormCascader"
          placeholder="请选择"
          @change="onChange(item.keyName)"
          filterable
          clearable
          :options="item.children"
          :props="{ checkStrictly: true, expandTrigger: 'hover' }"
        ></el-cascader>
      </el-form-item>
      <el-form-item v-else-if="item.type==='radio'" class="radioStyle" :label="item.label">
        <el-radio-group
          v-model="formData[item.keyName]"
          class="childrenItem"
          placeholder="请选择"
          @change="onChange"
        >
          <el-radio
            v-for="child in item.children"
            :key="child.keyName"
            :label="child.keyName"
            :value="child.keyName"
          >{{child.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-else-if="item.type==='checkbox'" class="checkboxStyle">
        <el-checkbox
          class="childrenItem"
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
        >{{item.label}}</el-checkbox>
      </el-form-item>
      <el-form-item v-else-if="item.type==='number'" :label="item.label" class="labelStyle">
        <el-input-number
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
          class="labelInputNumber"
          clearable
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item v-else-if="item.type==='dateRange'" :label="item.label" class="labelStyle">
        <el-date-picker
          v-model="formData[item.keyName]"
          @change="onChange(item.keyName)"
          class="dateRange"
          type="daterange"
          range-separator="-"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
    </div>
    <el-form-item v-if="showSearch">
      <elementButton size="mini" class="searchButton" @click="onSubmit">搜索</elementButton>
    </el-form-item>
  </el-form>
</template>

<style lang="scss">
.searchFormNew {
  //   border: 1px;
  margin: 0 1%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00c1de;
    background-color: #fff;
  }

  .el-radio__inner::after {
    background-color: #00c1de;
  }

  .el-radio__input.is-checked + .el-radio__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #00c1de;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #00c1de;
    background-color: #00c1de;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }
  .el-select-dropdown__item.hover {
    color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: #00c1de;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:hover {
    border-color: #00c1de;
  }

  .labelStyle {
    margin: 10px;
    width: auto;
    display: flex;
  }
  .checkboxStyle {
    margin: 10px;
    width: auto;
    display: flex;
  }
  .labelInput {
    width: 130px;
    height: 36px;
    line-height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
  .cascaderInput {
    width: auto;
    height: 36px;
    line-height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
  .labelInputNumber {
    width: 110px;
    height: 36px;
    line-height: 36px;
    .el-input__inner {
      height: 36px;
      line-height: 36px;
    }
  }
  .dateRange {
    width: 250px;

    .el-range-editor--mini.el-input__inner {
      height: 36px;
    }

    .el-range-editor.is-active,
    .el-range-editor.is-active:hover {
      border-color: #00c1de;
    }

    .el-date-table td.today span {
      color: #00c1de;
    }
  }
  .searchButton {
    margin: 10px;
    font-size: 14px;

    width: 60px;
    height: 36px;
    background: #00c1de;
    border-color: #00c1de;
    border-radius: 4px;
  }
  .radioStyle {
    margin: 10px;
    font-size: 14px;
    width: 300px;
    .childrenItem {
      min-width: 220px;
      .el-radio {
        margin-right: 10px;
      }
    }
  }
}
.el-select-dropdown__item.selected {
  color: #00c1de;
}
.searchFormCascader {
  .el-scrollbar__wrap {
    max-height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/searchFormNew.vue